import { render, staticRenderFns } from "./section-edit.vue?vue&type=template&id=0401a190&"
import script from "./section-edit.vue?vue&type=script&lang=js&"
export * from "./section-edit.vue?vue&type=script&lang=js&"
import style0 from "./section-edit.vue?vue&type=style&index=0&id=0401a190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports